export default __webpack_public_path__ + "static/ecommerceStoreVp1-972f05e93381c87a0c33b1b7e6977fa7.png";